(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoActionsV2Controller', InvoiceInfoActionsV2Controller);

    InvoiceInfoActionsV2Controller.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', 'InvoiceInfoCustom', 'DialogService', 'PaymentLogCustom', '$mdBottomSheet', '$window', 'CompanyCustomerCustom', '$mdDialog', '$mdMedia'];

    function InvoiceInfoActionsV2Controller($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, InvoiceInfoCustom, DialogService, PaymentLogCustom, $mdBottomSheet, $window, CompanyCustomerCustom, $mdDialog, $mdMedia) {

        var vm = this;

        vm.invoiceInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.findStatusStyle = findStatusStyle;
        vm.finalizeInvoiceInfo = finalizeInvoiceInfo;
        vm.voidInvoice = voidInvoice;
        vm.editInvoiceInfo = editInvoiceInfo;
        vm.settlementInvoice = settlementInvoice;
        vm.insertPayment = insertPayment;
        vm.isBalanced = isBalanced;
        vm.findBalanceStyle = findBalanceStyle;
        vm.deletePaymentLog = deletePaymentLog;
        vm.openMenu = openMenu;
        vm.originatorEv = null;
        vm.showOtherActionsButton = true;
        vm.canEditPaymentLog = canEditPaymentLog;
        vm.printInvoiceInfo = printInvoiceInfo;
        vm.goToCustomerDetail = goToCustomerDetail;
        vm.sendInvoiceToCustomer = sendInvoiceToCustomer;
        vm.showWithdrawFromWalletModal = showWithdrawFromWalletModal;

        vm.closeModal = closeModal;
        vm.okModal = okModal;

        $rootScope.$broadcast('hideNavBar');

        load();

        function load() {

            setRemainAmount();

        }

        function setRemainAmount() {
            vm.invoiceInfo.remainAmount = vm.invoiceInfo.finalPrice;
            var sumPayedAmount = 0;
            if (vm.invoiceInfo && vm.invoiceInfo.paymentLogs) {
                angular.forEach(vm.invoiceInfo.paymentLogs, function (payment) {
                    sumPayedAmount += payment.amount;
                })
            }

            vm.invoiceInfo.remainAmount -= sumPayedAmount;
        }

        function clear() {
        }

        function save() {
            // vm.isSaving = true;
            // if (vm.invoiceInfo.id !== null) {
            //     InvoiceInfo.update(vm.invoiceInfo, onSaveSuccess, onSaveError);
            // } else {
            //     InvoiceInfo.save(vm.invoiceInfo, onSaveSuccess, onSaveError);
            // }
        }

        function onSaveSuccess(result) {

            vm.isSaving = false;
            // $state.transitionTo('supplierPanel-v2.editOrderBag', {id: result.id});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $state.go('supplierPanel-v2.dashboard');

                return;
            }

            if ($rootScope.fromState && $rootScope.fromState.name) {
                if ($rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoList'
                    || $rootScope.fromState.name == 'supplierPanel-v2.newInvoiceInfo'
                    || $rootScope.fromState.name == 'supplierPanel-v2.editInvoiceInfo'
                    || $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail.editCompanyCustomer'
                    || $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail.delete'
                ) {
                        $state.go('supplierPanel-v2.invoiceInfoList', $rootScope.fromStateParams);
                   
                    return;
                } else {
                    if ($rootScope.fromStateParams) {
                        if($rootScope.fromState.name == "supplierPanel-v2.companyApprovalPaymentLogListV2") {
                            $state.go($rootScope.fromState.name, $rootScope.fromStateParams);    
                            return
                        }
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }

            $state.go('supplierPanel-v2.invoiceInfoList');

        }

        function okModal() {
            save();

        }


        function findStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }

        function voidInvoice() {

        }


        function editInvoiceInfo() {
            InvoiceInfoCustom.makeInvoiceEditable().save(vm.invoiceInfo.id, onMakeEditableSuccess, onMakeEditableError);

            function onMakeEditableSuccess(result) {
                $state.transitionTo('supplierPanel-v2.editInvoiceInfo', {id: vm.invoiceInfo.id});
            }

            function onMakeEditableError(result) {

            }
        }

        function insertPayment() {
            $uibModal.open({
                templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog-v2.html',
                controller: 'InvoiceInfoPaymentLogDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            traceCode: null,
                            paymentType: null,
                            createDate: null,
                            id: null,
                            invoiceInfoId: vm.invoiceInfo.id
                        };
                    }]
                }
            }).result.then(function (v) {

                vm.invoiceInfo.paymentLogs.push({
                    id: v.id,
                    traceCode: v.traceCode,
                    paymentType: v.paymentType,
                    createDate: v.createDate,
                    amount: v.amount,
                    moreInfo: v.moreInfo
                });

                reload();
            }, function () {
                //nothing
            });
        }

        function settlementInvoice() {
            if (vm.invoiceInfo.remainAmount == 0 || vm.invoiceInfo.finalPrice == 0)
                return;

            var paymentLog = {};
            paymentLog.amount = vm.invoiceInfo.remainAmount;
            paymentLog.paymentType = 'UNKNOWN';
            paymentLog.invoiceInfoId = vm.invoiceInfo.id;

            PaymentLogCustom.createPaymentLogByInvoiceInfoId().save(paymentLog, onSettlementSaveSuccess, onSettlementSaveError);


            function onSettlementSaveSuccess(result) {
                vm.invoiceInfo.paymentLogs.push({
                    id: result.id,
                    traceCode: result.traceCode,
                    paymentType: result.paymentType,
                    createDate: result.createDate,
                    amount: result.amount
                });

                vm.invoiceInfo.remainAmount -= result.amount;
            }

            function onSettlementSaveError() {

            }
        }

        function isBalanced() {
            return (vm.invoiceInfo.remainAmount == 0);

        }

        function findBalanceStyle() {
            if (vm.invoiceInfo.remainAmount == 0) {
                return "panel-success";
            } else {
                return "panel-danger";
            }
        }

        function reload() {
            InvoiceInfoCustom.getInvoiceWithItemsById(vm.invoiceInfo.id).query(function (data) {
                vm.invoiceInfo = data;
                setRemainAmount();
            });


        }


        function finalizeInvoiceInfo() {

            if (vm.invoiceInfo.status == "SETTLEMENT") {
                DialogService.showAlert("هشدار", "وضعیت فاکتور نهایی شده است");
                return;
            }

            if (vm.invoiceInfo.finalPrice > 0 && vm.invoiceInfo.remainAmount > 0) {
                DialogService.showAlert("هشدار", "برای نهایی کردن فاکتور، باید مبلغ فاکتور تسویه شده باشد");
                return;
            }

            DialogService.showConfirmV2("بعد از نهایی کردن فاکتور امکان ویرایش وجود ندارد. ادامه عملیات را تایید می فرمایید ؟").then(function () {

                InvoiceInfoCustom.finalizeInvoiceInfo().save(vm.invoiceInfo.id, finalizeSuccess, finalizeError);

            });


            function finalizeSuccess(result) {
                vm.invoiceInfo.status = "SETTLEMENT";
                reload();
            }

            function finalizeError(result) {

            }
        }

        function deletePaymentLog(paymentLog) {
            if(paymentLog.managerApprovalStatus === 'CHECKING' || paymentLog.managerApprovalStatus === 'DENIED' || paymentLog.managerApprovalStatus === 'APPROVED') return
            if (paymentLog != null) {
                if (paymentLog.paymentType == 'ONLINE')
                    return;

                DialogService.showConfirmV2("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    PaymentLogCustom.deletePaymentLogById().delete({id: paymentLog.id},
                        function () {
                            reload();
                        });

                });
            }
        }

        function openMenu($mdOpenMenu, ev) {
            vm.originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function canEditPaymentLog(paymentLog) {


            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID'))
                return false;

            if (paymentLog && paymentLog.paymentType == 'ONLINE')
                return false;

            return true;
        }

        function deleteInvoiceInfo() {
            $state.go('supplierPanel-v2.invoiceInfoDetail.delete', {id: vm.invoiceInfo.id});
        }

        vm.mainActions = function () {
            openBottomSheet('MAIN_ACTIONS');
        }
        vm.otherActions = function () {
            openBottomSheet('OTHER_ACTIONS');
        }


        function openBottomSheet(mode) {
            $mdBottomSheet.show({
                templateUrl: 'app/entities/invoice-info/invoice-info-bottom-sheet-template.html',
                controller: 'InvoiceInfoBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: (function () {
                        return {
                            invoiceInfo: vm.invoiceInfo,
                            mode: mode,
                            showUseCredit: vm.invoiceInfo.remainAmount > 0 && vm.canEditPaymentLog()
                        };
                    })


                },
            }).then(function (result) {
                switch (result) {
                    case 'editInvoiceInfo':
                        editInvoiceInfo();
                        break;
                    case 'finalizeInvoiceInfo':
                        finalizeInvoiceInfo();
                        break;
                    case 'deleteInvoiceInfo':
                        deleteInvoiceInfo();
                        break;
                    case 'settlementInvoice':
                        settlementInvoice();
                        break;
                    case 'insertPayment':
                        insertPayment();
                        break;
                    case 'sendInvoiceToCustomer':
                        sendInvoiceToCustomer();
                        break;
                    case 'useCredit':
                        showWithdrawFromWalletModal();
                        break;

                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }

        function printInvoiceInfo() {
            var url = $state.href('supplierPanel-v2.printInvoiceInfo', {id: vm.invoiceInfo.id});
            $window.open(url, '_blank');
        }


        function goToCustomerDetail() {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(vm.invoiceInfo.customer.id).query().$promise.then(onGetSuccess);
                    }
                });
        }

        function onGetSuccess(result) {

            vm.companyCustomer = result;
            $state.go('supplierPanel-v2.invoiceInfoDetail.editCompanyCustomer', {id: vm.companyCustomer.id});

        }

        function sendInvoiceToCustomer() {

            InvoiceInfoCustom.sendInvoiceInfoToCustomer().save(vm.invoiceInfo.id, onSuccess, onError);

            function onSuccess() {

            }

            function onError() {

            }
        }
        $scope.calcManagerApprovalStatus = function(status) {
             switch(status) {
                case 'APPROVED': return 'تایید شده';
                case 'DENIED': return 'رد شده';
                case 'CHECKING': return 'درحال بررسی';
                default: return '';
            }
        };
        $scope.getStatusClass = function(status) {
            switch(status) {
                case 'APPROVED': return 'status-approved';
                case 'DENIED': return 'status-denied';
                case 'CHECKING': return 'status-chicking';
                default: return 'status-unknown';
            }
        };

        function showWithdrawFromWalletModal() {
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/wallet/wallet-withdraw-balance-dialog.html',
                controller: ['$scope', 'customerId', 'withdrawAmount', 'invoiceInfoId', function ($scope, customerId, withdrawAmount, invoiceInfoId) {
                    $scope.customerId = customerId;
                    $scope.withdrawAmount = withdrawAmount;
                    $scope.invoiceInfoId = invoiceInfoId;
                }],
                locals: {
                    customerId: vm.invoiceInfo.customer.id, 
                    withdrawAmount: vm.invoiceInfo.remainAmount,
                    invoiceInfoId: vm.invoiceInfo.id
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(function (res) {
                if (res) {
                    reload()
                    // onSettlementSaveSuccess(res)
                }
            });
        }
         $scope.getDynamicStyleRemoveIcon = function(paymentLog) {
            var color = "red";
            if(paymentLog.onlineGateway === "WALLET_CUSTOMER_WEB")
                color = 'unset';
            return {
                color: color
            };
        };
    }
})();
